module.exports = __webpack_public_path__ + "jm.svg?a7ca963e01f0017b53e1b3655361fa79";